import * as yup from 'yup';
import { useFormHandler } from './useFormHandler';

export type QuizzFormValues = {
  type?: string;
  name?: string;
  picture?: File;
  reponse1?: string;
  reponse2?: string;
  reponse3?: string;
  reponse4?: string;
  description?: string;
  position?: number;
  duration?: number;
};

const quizzValidationSchema = (mode: 'create' | 'update') =>
  yup.object({
    type: yup
      .string()
      .when([], {
        is: () => mode === 'create',
        then: (schema) => schema.required('Veuillez selectionner le type'),
        otherwise: (schema) => schema.notRequired(),
      })
      .label('Type'),
    name: yup
      .string()
      .when([], {
        is: () => mode === 'create',
        then: (schema) => schema.required('Veuillez saisir la question'),
        otherwise: (schema) => schema.notRequired(),
      })
      .label('Name'),
    description: yup
      .string()
      .when([], {
        is: () => mode === 'create',
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.notRequired(),
      })
      .label('Description'),
    picture: yup
      .mixed<File>()
      .when([], {
        is: () => mode === 'create',
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.notRequired(),
      })
      .label('Picture'),
    reponse1: yup
      .string()
      .when([], {
        is: () => mode === 'create',
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.notRequired(),
      })
      .label('Reponse1'),
    reponse2: yup
      .string()
      .when([], {
        is: () => mode === 'create',
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.notRequired(),
      })
      .label('Reponse2'),
    reponse3: yup
      .string()
      .when([], {
        is: () => mode === 'create',
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.notRequired(),
      })
      .label('Reponse3'),
    reponse4: yup
      .string()
      .when([], {
        is: () => mode === 'create',
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.notRequired(),
      })
      .label('Reponse4'),
    position: yup
      .number()
      .when([], {
        is: () => mode === 'create',
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.notRequired(),
      })
      .min(0, 'La position ne peut pas être négative')
      .label('Position'),
    duration: yup
      .number()
      .when([], {
        is: () => mode === 'create',
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.notRequired(),
      })
      .min(0, 'La durée ne peut pas être négative')
      .label('Duration'),
  });

export const useHandleQuizzForm = (mode: 'create' | 'update') => {
  const { register, handleSubmit, errors, setValue, reset, getValues } =
    useFormHandler<QuizzFormValues>(quizzValidationSchema(mode));
  return {
    register,
    handleSubmit,
    setValue,
    errors,
    reset,
    getValues,
  };
};
